import { create } from 'zustand';

interface Node {
  id: string;
  label: string;
  type: string;
  importance: number;
  position?: { x: number; y: number };
  parent_id?: string;
  zoomable: boolean;
  level: number;
  tags: string[];
  emotion?: {
    valence: number;
    arousal: number;
    label: string;
    visual_hint: string;
  };
  phrase?: string;
  recommendation?: string;
  is_issue?: boolean;
  salience?: number;
  issue_ranking_score?: number;
  issue_ranking_method?: string;
  metadata?: Record<string, any>;
}

interface Edge {
  from: string;
  to: string;
  type: string;
  label?: string;
}

interface Graph {
  nodes: Node[];
  edges: Edge[];
  meta?: {
    graph_type: string;
    summary: {
      dominant_emotion: string;
      graph_center: string;
    };
  };
  session_id?: string;
  user_id?: string;
  timestamp?: string;
  title?: string;
  issue_node_id?: string;
  issue_node?: {
    id: string;
    text: string;
    type: string;
    ranking_score: number;
    ranking_method: string;
    confidence: number;
    salience: number;
    centrality_score: number;
    semantic_score: number;
    metadata: any;
  };
  segmentation?: {
    segment_type?: string | null;
    segment_confidence?: number | null;
    segment_version?: string | null;
    metadata?: Record<string, any> | null;
  };
}

interface GraphStore {
  graph: Graph;
  setGraph: (graph: Graph) => void;
  clearGraph: () => void;
  selectedOptionIds: string[];
  toggleOptionId: (id: string) => void;
  clearOptionIds: () => void;
}

export const useGraphStore = create<GraphStore>((set) => ({
  graph: { nodes: [], edges: [] },
  setGraph: (graph) => set({ graph }),
  clearGraph: () => set({ graph: { nodes: [], edges: [] } }),
  selectedOptionIds: [],
  toggleOptionId: (id) =>
    set((state) => ({
      selectedOptionIds: state.selectedOptionIds.includes(id)
        ? state.selectedOptionIds.filter((x) => x !== id)
        : [...state.selectedOptionIds, id],
    })),
  clearOptionIds: () => set({ selectedOptionIds: [] }),
}));